/**
 * an empty function that does nothing
 */
export function nullFunction() {
    // nullFunction do nothing
}
